import { combineReducers } from "redux";
import { calNum } from "./calNum";

export const mainReducer = combineReducers({
  calNum: calNum,
});
